import PropTypes from 'prop-types';
import { createContext, useEffect, useReducer, useCallback } from 'react';
// utils
import myAxios from '../utils/axios';
import { isValidToken, setSession, getPayload } from './utils';
import { RAINBOW_VAR, SERVER_API } from '../config';
// locales
import { useLocales } from '../locales';
// Redux
import { useDispatch } from "react-redux";
import { setSSEForREC } from "../redux/slices/recordsSlice";

// import rainbowSDK from "rainbow-web-sdk";


// ----------------------------------------------------------------------


const initialState = {
  isInitialized: false,
  isAuthenticatedWithOAuth: false,
  token: null,
  isAuthenticatedOnBackend: false,
  isSSELinked: false,
  isUserConnectedOnRainbow: false,
  companyConfigData: null,
  user: null,
  isError: false,
  error: null
};

const reducer = (state, action) => {
  if (action.type === 'INITIAL') {
    return {
      ...state,
      isInitialized: action.payload.isInitialized,
      token: action.payload.token,
      isAuthenticatedWithOAuth: action.payload.isAuthenticatedWithOAuth,
      isAuthenticatedOnBackend: false,
      isSSELinked: false,
      user: action.payload.user,
    };
  }
  if (action.type === 'LOGIN') {
    return {
      ...state,
      isAuthenticatedOnBackend: action.payload.isAuthenticatedOnBackend,
      user: action.payload.user, 
    };
  }
  if (action.type === 'LOGINONRAINBOW') {
    return {
      ...state,
      isUserConnectedOnRainbow: action.payload.isUserConnectedOnRainbow,
      companyConfigData: action.payload.companyConfigData
    };
  }
  if (action.type === 'LINKED') {
    return {
      ...state,
      isSSELinked: action.payload.isSSELinked,
    };
  }
  if (action.type === 'LOGOUT') {
    return {
      ...state,
      isAuthenticatedWithOAuth: false,
      isAuthenticatedOnBackend: false,
      isSSELinked: false,
      user: null,
    };
  }
  if (action.type === 'ERROR') {
    return {
      ...state,
      isError: action.payload.isError,
      error: action.payload.error
    };
  }

  return state;
};

// ----------------------------------------------------------------------

export const AuthContext = createContext(null);

// ----------------------------------------------------------------------

AuthProvider.propTypes = {
  children: PropTypes.node,
};

export function AuthProvider({ children }) {
  const [state, dispatchPerso] = useReducer(reducer, initialState);
  const { translate } = useLocales();
  const dispatch = useDispatch();

  // INIT
  const initialize = useCallback(async () => {
    try {
      console.log("[Click to Connect] Version: 2.32.03..")      
      // console.log("process.env.REACT_APP_RAINBOW_HOST : ", process.env.REACT_APP_RAINBOW_HOST)

      // console.log("RAINBOW_VAR : ", RAINBOW_VAR)
      // console.log("SERVER_API : ", SERVER_API)

      // if (localStorage.getItem('timeLeftMS')) console.log("timeLeftMS before logout: ", localStorage.getItem('timeLeftMS'))
      if (localStorage.getItem('diffTimeLog')) console.log("diffTimeLog before logout: ", localStorage.getItem('diffTimeLog'))

      if (localStorage.getItem("error401")) setTimeout(() => { localStorage.removeItem('error401'); window.location.hash = ''}, 1000);
      let accessToken = localStorage.getItem('accessToken') || "";
      let user = {};

      if(accessToken || (window.location.hash && window.location.hash.startsWith("#access_token="))){
        // console.log("[AuthProvider] Le token est disponible !");
        accessToken = accessToken || window.location.hash.replace("#access_token=","").split("&")[0];
        user = await getPayload(accessToken).user;      
        console.log("[AuthProvider] user : ", user);
      } 

      if (accessToken && isValidToken(accessToken)) {
        setSession(accessToken);
        dispatchPerso({
          type: 'INITIAL',
          payload: {
            isInitialized: true,
            isAuthenticatedWithOAuth: true,
            token: accessToken,
            user
          },
        });
      } else {
        dispatchPerso({
          type: 'INITIAL',
          payload: {
            isInitialized: false,
            isAuthenticatedWithOAuth: false,
            token: null,
            user: null
          },
        });
      }

      // FACEBOOK OAUTH
      const companyId = localStorage.getItem('companyId')
      const currentUrl = window.location.href;
      const urlParams = new URLSearchParams(currentUrl.split('?')[1]);
      if(urlParams.get('code')){
        let code = urlParams.get('code');
        const response = await myAxios.post(SERVER_API.server+'/whatsapp/activation', {type: 'code', item: code, companyId: companyId, botId: user.id});
        if (response.data.state === "activated") {
          console.log("[AuthProvider] Whatsapp a bien ete active");
        } else if (response.data.state === "reconnected") {
          console.log("[AuthProvider] Whatsapp a bien ete reconnectée");
          localStorage.setItem('metaAppJustReconnected', "true");
        } else if (response.data.state === "transfered") {
          console.log("[AuthProvider] Whatsapp a bien ete transferée");
        } else {
          console.log("[AuthProvider] Whatsapp n'est pas pu etre active");
        }
      } 

    } catch (error) {
      console.error(error);
      dispatchPerso({
        type: 'INITIAL',
        payload: {
          isInitialized: false,
          isAuthenticatedWithOAuth: false,
          token: null,
          user: null
        },
      });
    }
  }, []);


  // REDIRECT & LOGIN WITH OAUTH
  const redirectToOAuth = () => {
    let redirect = "https://"
      + RAINBOW_VAR.host
      + "/api/rainbow/authentication/v1.0/oauth/authorize?response_type=token&client_id="
      + RAINBOW_VAR.appId
      + "&redirect_uri="
      + RAINBOW_VAR.appOAuthRedirectUri
      + "&state=admin&scope=all"
    ;
    window.location.replace(redirect);
  };


  // // userConnectedOnRainbow
  // const userConnectedOnRainbow = async () => {
  //   try {
  //     console.log("[AuthProvider] userConnectedOnRainbow");

  //     //! virer le sdkWEB possible ?
  //       // je pense que oui
  //     //! faudra ensuite coder la connexion via le server
  //       // ou mtn...


  //     let userCustomData = {};
  //     rainbowSDK.initialize("", "").then( () => {
  //       console.log("[RainbowSDKService] SDK started correctly");
  //         rainbowSDK.connection.signinOnRainbowHostedWithToken(state.token, "openrainbow.net")
  //           .then((account) => {
  //             userCustomData = account.userData;
  //             console.log("[App] logged in ", userCustomData);
  //             // ConfigService.init(token, account.userData.id);
  //             // ConfigService.getConfig().then(result=>{
  //             //   console.log("[App] Config : ", account.userData.id);
  //             //   console.log("[App] Config : ", config);
  //             //     setConfig(result);
  //             //     setConfigRetrieved(true);
  //             //     //config = result;
  //             //   }); 
  //             dispatchPerso({
  //               type: 'LOGINONRAINBOW',
  //               payload: {
  //                 isUserConnectedOnRainbow: true,
  //                 customData: userCustomData
  //                 // user,
  //               },
  //             });
  //           }).catch((error) => {
  //             console.log("[App] Error login in ", error);
  //             // setErrorLogin("errorLogin")
  //             // ConfigService.setUserId("");
  //           });    
  
  //       }).catch( (error) => {
  //         console.log("[RainbowSDKService] SDK not started !!!");
  //       });



      
  //   } catch (error) {
  //     console.log("[AuthProvider] [Axios Error] : ", error);
      
  //     dispatchPerso({
  //       type: 'LOGINONRAINBOW',
  //       payload: {
  //         isUserConnectedOnRainbow: false,
  //         customData: null
  //         // user: null,
  //       },
  //     });

  //     dispatchPerso({
  //       type: 'ERROR',
  //       payload: {
  //         isError: true,
  //         error: error
  //       },
  //     });

  //     return logout();
  //   }
  // }

  // USER CHECK ON BACKEND
  const userCheckOnBackend = async () => {
    try {
      console.log("[AuthProvider] User check on Backend");
      

      //! comment ca se passe sur le server C2C ? ==> faire pareil
      //! en gros après avoir recup le token je lenvoi au backend
      //! ensuite il me renvoi mon user si il est valide

      //! seul ce premier call peut se faire vers le server generic (pour tous les customers), les autres call se font sur le server de leur ns

      // // envoi du token au backend  //  reponse = un user
      const response = await myAxios.post(SERVER_API.server+'/oauth/callback', {data: {token: state.token, userId: state.user.id}}); // SERVER_API.tokenCheck
      // const vipsResponse = await myAxios.get(SERVER_API.server + '/vips/data/' +  response.data.data.customMongoUser.userBotAdminCompanyID, {headers: {'X-rainbow-token': state.token}}); // SERVER_API.tokenCheck
      let oldCustomData = response.data.data.user;
      let customMongoUser = response.data.data.customMongoUser;
      let waApp = response.data.data.waApp;
      let avatar = response.data.data.avatar;
      let user = {oldCustomData: oldCustomData, customMongoUser: customMongoUser, avatar: avatar, waApp: waApp}
      // let user = {oldCustomData: oldCustomData, customMongoUser: customMongoUser, avatar: avatar, vipsData: vipsResponse.data.vipsData}
      localStorage.setItem('backendURL', customMongoUser.otherSettings.backEndUrl)
      localStorage.setItem('companyId', customMongoUser.userBotAdminCompanyID)

      console.log("[AuthProvider] SERVER_API: ", SERVER_API);
      // console.log("[AuthProvider] backendURL: ", localStorage.getItem('backendURL'));

      // console.log("[AuthProvider] oldCustomData back from backend : ", oldCustomData);
      // console.log("[AuthProvider] customMongoUser back from backend userBotAdminEmail : ", customMongoUser.userBotAdminEmail);
      // console.log("[AuthProvider] waApp back from backend rainbow_admin_bot_id : ", waApp && waApp.rainbow_admin_bot_id ? waApp.rainbow_admin_bot_id : null);
      // console.log("[AuthProvider] avatar : ", avatar);
      
      console.log("[AuthProvider] User checked on Backend");

      dispatchPerso({
        type: 'LOGIN',
        payload: {
          isAuthenticatedOnBackend: true,
          user,
        },
      });

    } catch (err) {
      let error = {};
      if (err.response) {error.type = "Response"; error.customMessage = translate('error.responseType')}
      else if (err.request) {error.type = "Request"; error.customMessage = translate('error.requestType')}
      else {error.type = "Other"; error.customMessage = translate('error.otherType')}
      error.status = err.response ? err.response.status : null;
      error.code = err.response ? err.response.code : null;
      error.message = err.message ? err.message : null;
      error.baseUrl = err.config ? err.config.baseURL : null;
      error.apiUrl = err.config ? err.config.url : null;
      console.log("[AuthProvider] [Axios Error] : ", error);

      dispatchPerso({
        type: 'LOGIN',
        payload: {
          isAuthenticatedOnBackend: false,
          user: null,
        },
      });

      dispatchPerso({
        type: 'ERROR',
        payload: {
          isError: true,
          error: err
        },
      });

      return logout();
    }
  }  


  // SSE
  // const getSSELink = () => {
  //   console.log('[AuthProvider] getSSELink')

  //   try {
  //     // EventSource :
  //     let countError = 0;
  //     var url = SERVER_API.server + "/v1.0/companies/" + state.user.companyId + "/sse/" + state.user.sseToken
  //     const eventSource = new EventSource(url);
      
  //     // Reception des events open, count & test :
  //     eventSource.addEventListener('open', () => {
  //       console.log('[AuthProvider] SSE connected')
  //       countError = 0;
  //       dispatchPerso({
  //         type: 'LINKED',
  //         payload: {
  //           isSSELinked: true
  //         },
  //       });
  //     });
      
  //     // eventSource.addEventListener('count', event => console.log('count message', JSON.parse(event.data)));
  //     // eventSource.addEventListener('test', event => console.log('test message', JSON.parse(event.data)));

  //     // Reception des events sur les exports & Maj du DOM (state: new | pending | download| upload | exported | failed)
  //     eventSource.addEventListener('export', event => {
  //       let exportEvent = JSON.parse(event.data)
  //       // console.log("[AuthProvider] exportEvent: ", exportEvent)
  //       let sseObj = {
  //         state: exportEvent.state || undefined,
  //         type: exportEvent.type === "recording" ? 'recording' : "cdr",
  //         id: exportEvent.recordId || undefined,
  //         destinationName: exportEvent.destination.name || undefined,
  //         failure: exportEvent.failure || undefined,
  //         connection: "online"
  //       }

  //       // Update Redux pour MAJ le DOM
  //       if (exportEvent.state === 'download') {
  //         console.log('[AuthProvider] This record is downloaded: ', exportEvent.recordId)
  //         exportEvent.type === "recording" ? dispatch(setSSEForREC(sseObj)) : dispatch(setSSEForCDR(sseObj))
  //       } 
  //       else if (exportEvent.state === 'exported') {
  //         console.log('[AuthProvider] This record id exported: ', exportEvent.recordId)
  //         exportEvent.type === "recording" ? dispatch(setSSEForREC(sseObj)) : dispatch(setSSEForCDR(sseObj))
  //       } 
  //       else if (exportEvent.state === "failed") {
  //         if (exportEvent.failure === 'Export error, database problem') {
  //           console.log(`[AuthProvider] The record's export "${exportEvent.recordId}" failed because the Drive "${exportEvent.destination.name}" is not working`)
  //         } else {
  //           console.log(`[AuthProvider] The record's export "${exportEvent.recordId}" failed`)
  //         }
  //         exportEvent.type === "recording" ? dispatch(setSSEForREC(sseObj)) : dispatch(setSSEForCDR(sseObj))
  //       } 
  //       else {
  //         console.log('[AuthProvider] record export event (upload ou pending): ', exportEvent);
  //       }
  //     });


  //     // Reception des events sur les erreurs & Logout :
  //     eventSource.addEventListener('error', event => {
  //       let sseObj = {
  //         connection: "offline"
  //       }
        
  //       // Perte de connexion définitif avec le serveur
  //       if (eventSource.readyState === EventSource.CLOSED) {
  //           console.log('[AuthProvider] The application is closing, please retry later...');
  //           dispatchPerso({
  //             type: 'LINKED',
  //               payload: {
  //                 isSSELinked: false
  //               },
  //           });
  //           setTimeout(() => {
  //             logout();
  //           }, 3000);
  //       }
  //       // Perte de connexion temporaire avec le serveur
  //       else if (eventSource.readyState === EventSource.CONNECTING) {
  //         // console.log(countError);
  //         if (countError === 3) { // logout au bout de 3
  //           console.log('[AuthProvider] The application is closing, please retry later...');
  //           setTimeout(() => {
  //             eventSource.close();
  //             logout();
  //           }, 3000);
  //         } else {
  //           console.log('[AuthProvider] The SSE connection is pending...');
  //           // dispatch(setSSEForREC(sseObj))
  //           // dispatch(setSSEForCDR(sseObj))
  //           countError = countError + 1;
  //         }
  //       }
  //       // Autres...
  //       else {
  //         // if (countError === 2) { // logout au bout de 2
  //           console.log('[AuthProvider] The application is closing, please retry later...');
  //           console.log('[AuthProvider] The SSE connection is dead (other): ', event);
  //           setTimeout(() => {
  //             eventSource.close();
  //             logout();
  //           }, 3000);
  //         // } else {
  //           // console.log('[AuthProvider] The SSE connection is dead (other): ', event);
  //           // dispatch(setSSEForREC(sseObj))
  //           // dispatch(setSSEForCDR(sseObj))
  //           // countError = countError + 1;
  //         // }
  //       }
  //     });

  //   } catch (err) {
  //     let error = {};
  //     if (err.response) {error.type = "Response"; error.customMessage = translate('error.responseType')}
  //     else if (err.request) {error.type = "Request"; error.customMessage = translate('error.requestType')}
  //     else {error.type = "Other"; error.customMessage = translate('error.otherType')}
  //     error.status = err.response ? err.response.status : null;
  //     error.code = err.response ? err.response.code : null;
  //     error.message = err.message ? err.message : null;
  //     error.baseUrl = err.config ? err.config.baseURL : null;
  //     error.apiUrl = err.config ? err.config.url : null;
  //     console.log("[AuthProvider] [Axios Error] : ", error);

  //     dispatchPerso({
  //       type: 'LINKED',
  //         payload: {
  //           isSSELinked: false
  //         },
  //     });

  //     dispatchPerso({
  //       type: 'ERROR',
  //       payload: {
  //         isError: true,
  //         error: error
  //       },
  //     });

  //     return logout();
  //   }

  // };

  // LOGOUT
  const logout = async () => {
    setSession(null);
    dispatchPerso({ type: 'LOGOUT' });
  };


  // ----------------------------------------------------------------------

  useEffect(() => {
    initialize();
  }, [initialize]);

  useEffect(() => {
    if (state.isAuthenticatedWithOAuth) userCheckOnBackend();
  }, [state.isAuthenticatedWithOAuth]);

  // useEffect(() => {
  //   if (state.isAuthenticatedOnBackend) userConnectedOnRainbow();
  // }, [state.isAuthenticatedOnBackend]);

  // useEffect(() => {
  //   if (state.isAuthenticatedOnBackend) getSSELink();
  // }, [state.isAuthenticatedOnBackend]);

  // ----------------------------------------------------------------------

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'oauth',
        redirectToOAuth,
        logout
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
